import FormRegister from "../../components/FormRegister";
import Layout from "../../components/Layout";
import Title from "../../components/Title";

function Register() {
    return (
        <Layout>
            <section className="w-full h-fit lg:h-fit py-[60px] px-[20px] text-center bg-[#f9f9f9]">
                <Title title="Đăng Ký Học" subTitle="Điền thông tin để đăng ký khóa học mới"/>
                <div className="max-w-[800px] h-fit mx-auto shadow-default bg-white rounded-[8px] mt-[40px] lg:p-[30px] lg:pb-[50px] p-[30px]">
                    <FormRegister />
                </div>
            </section>
        </Layout>
    );
}

export default Register;